import { HELP_ICON_HTML, bindStartTourLink, bindElementHandoffClick, unbindElementHandoffClick } from '../../tourUi'
import { bindReporteManualTourLink } from './reporteManualTour'

const selectProtocol = (protocol) => {
    const radio = document.querySelector(`[data-tour="protocol-${protocol}"] input`)

    if (radio && !radio.checked) {
        radio.click()
    }
}

const selectLns = () => {
    const radio = document.querySelector('[data-tour="protocol-lns"] input')

    if (radio && !radio.checked) {
        radio.click()
    }
}

const getSavedProtocol = () => getEditRoot()?.getAttribute('data-protocolo-salvo') || getEditRoot()?.getAttribute('data-protocolo') || ''

const restoreSavedProtocol = (savedProtocol) => {
    const protocol = savedProtocol || getSavedProtocol()
    if (!protocol) return

    if (protocol === 'lns_interno') {
        selectLns()
        return
    }

    if (protocol === 'via_gateway') {
        selectProtocol('gateway')
        return
    }

    selectProtocol(protocol)
}

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }

    return tabElement
}

const selectProtocolAndMoveNext = (tourManager, protocol, nextSelector) => () => {
    selectProtocol(protocol)

    tourManager.waitForElement(nextSelector)
        .then(() => tourManager.moveNext())
        .catch(() => {})
}

const selectProtocolAndMovePrev = (tourManager, protocol, prevSelector) => () => {
    selectProtocol(protocol)

    tourManager.waitForElement(prevSelector)
        .then(() => tourManager.movePrevious())
        .catch(() => {})
}

const clickTabAndMoveNext = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.moveNext(), 150)
}

const clickTabAndMovePrev = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.movePrevious(), 150)
}

const getEquipamentoId = () => {
    const path = window.location.pathname
    const fromEdit = path.match(/\/equipamento\/(\d+)\/editar/)
    if (fromEdit) return fromEdit[1]

    const fromParam = path.match(/\/campo-parametrizado\/(\d+)/)
    if (fromParam) return fromParam[1]

    const fromCmd = path.match(/\/comando-customizado\/(\d+)/)
    if (fromCmd) return fromCmd[1]

    return null
}

const editPath = (equipamentoId) => `/equipamento/${equipamentoId}/editar`

const getEditRoot = () => document.querySelector('[data-tour="equipamento-edit-root"]')

const hasCommunicated = () => getEditRoot()?.getAttribute('data-comunicou') === 'true'

const hasParameters = () => getEditRoot()?.getAttribute('data-tem-parametros') === 'true'

const isMqttEquipment = () => getEditRoot()?.getAttribute('data-protocolo') === 'mqtt'
const isGatewayEquipment = () => getEditRoot()?.getAttribute('data-is-gateway') === 'true'
const isVirtualEquipment = () => getEditRoot()?.getAttribute('data-is-virtual') === 'true'

const hasNovoParametroDisponivel = () => {
    const button = document.querySelector('[data-tour="param-novo-btn"]')
    return Boolean(button && !button.classList.contains('disabled'))
}

const canShowParamTour = () =>
    hasCommunicated() ||
    hasParameters() ||
    hasNovoParametroDisponivel() ||
    isVirtualEquipment()

const isLnsProtocol = () => getEditRoot()?.getAttribute('data-protocolo') === 'lns_interno'
const hasLnsOption = () => Boolean(document.querySelector('[data-tour="protocol-lns"]'))
const hasAccessState = () => Boolean(document.querySelector('[data-tour="form-estado-acesso"]'))
const hasCampoGateway = () => {
    const element = document.querySelector('[data-tour="form-campo-gateway"]')
    return Boolean(element && getComputedStyle(element).display !== 'none')
}

const getImportTableContent = (prefix) => () =>
    document.querySelector(`[data-tour="${prefix}-import-checkbox-area"] .afira-table-content`) ||
    document.querySelector(`[data-tour="${prefix}-import-modal-wrap"]`)?.closest('.modal-content')?.querySelector('.afira-table-content')

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))

const selectImportGlobalTab = (prefix) => {
    const tabList = document.querySelector(`[data-tour="${prefix}-import-tabs"]`)
    if (!tabList) return false

    const tabs = tabList.querySelectorAll('.react-tabs__tab')
    const globalTab = tabs[1]

    if (!globalTab) return false

    if (!globalTab.classList.contains('react-tabs__tab--selected')) {
        globalTab.click()
    }

    return true
}

const openDropdownAndImport = (tourManager, optionsSelector, importSelector, wrapSelector) => () => {
    document.querySelector(optionsSelector)?.click()

    setTimeout(() => {
        document.querySelector(importSelector)?.click()

        tourManager.waitForElement(wrapSelector)
            .then(() => tourManager.moveNext())
            .catch(() => {})
    }, 150)
}

const ensureImportModalOpen = (prefix) => async (tourManager) => {
    const readySelector = `[data-tour="${prefix}-import-tabs"]`

    if (!document.querySelector(readySelector)) {
        const tabSelector = prefix === 'param'
            ? '[data-tour="tab-parametrizacao"]'
            : '[data-tour="tab-comandos"]'
        const optionsSelector = `[data-tour="${prefix}-options"]`
        const importSelector = `[data-tour="${prefix}-importar"]`

        clickTab(tabSelector)
        await delay(150)

        document.querySelector(optionsSelector)?.click()
        await delay(150)

        document.querySelector(importSelector)?.click()
        await tourManager.waitForElement(readySelector)
    }

    selectImportGlobalTab(prefix)
    await delay(150)
    await tourManager.waitForElement(`[data-tour="${prefix}-import-checkbox-area"]`)
}

const closeModalAndMoveNext = (tourManager, closeSelector) => () => {
    document.querySelector(closeSelector)?.click()
    setTimeout(() => tourManager.moveNext(), 200)
}

const closeModalAndMovePrev = (tourManager, closeSelector) => () => {
    document.querySelector(closeSelector)?.click()
    setTimeout(() => tourManager.movePrevious(), 200)
}

const goToEditStep = (tourManager, equipamentoId, selector, index, tabSelector) =>
    tourManager.navigateAndWait(editPath(equipamentoId), '[data-tour="equipamento-edit-root"]', index)
        .then(async () => {
            if (tabSelector) {
                clickTab(tabSelector)
                await delay(200)
            }

            if (selector && selector !== '[data-tour="equipamento-edit-root"]') {
                await tourManager.waitForElement(selector).catch(() => null)
            }

            setTimeout(() => tourManager.moveTo(index), 150)
        })
        .catch(() => {})

const prepareLastProtocolDetails = (lnsActive) => {
    clickTab('[data-tour="tab-protocolo"]')

    if (lnsActive) {
        selectLns()
        return '[data-tour="detalhes-comunicacao-lns_interno"]'
    }

    selectProtocol('http')
    return '[data-tour="detalhes-comunicacao-http"]'
}

const goBackToLastProtocolStep = (tourManager, indexLastProtocolStep, lnsActive) => {
    const selector = prepareLastProtocolDetails(lnsActive)

    tourManager.waitForElement(selector)
        .then(() => setTimeout(() => tourManager.moveTo(indexLastProtocolStep), 150))
        .catch(() => tourManager.moveTo(indexLastProtocolStep))
}

const buildMqttProtocolSteps = (tourManager, { skipGatewayOption = false } = {}) => {
    const steps = [
        {
            element: '[data-tour="protocol-mqtt"]',
            popover: {
                title: 'MQTT',
                description: 'Em MQTT é possivel realizar alterações nos tópicos de comunicação do equipamento. Clique em <strong>Próximo</strong> para ver os campos.',
                side: 'bottom',
                align: 'start',
                onNextClick: selectProtocolAndMoveNext(
                    tourManager,
                    'mqtt',
                    '[data-tour="mqtt-topicos-personalizados"]'
                ),
            },
        },
        {
            element: '[data-tour="mqtt-topicos-personalizados"]',
            popover: {
                title: 'Tópicos personalizados',
                description: 'Ao marcar, você define os próprios tópicos. Depois de salvar com essa opção ativa, ela não poderá ser desativada.',
                side: 'bottom',
                align: 'start',
                onPrevClick: selectProtocolAndMovePrev(tourManager, 'mqtt', '[data-tour="protocol-mqtt"]'),
            },
        },
        {
            element: '[data-tour="mqtt-topico-publicar"]',
            popover: {
                title: 'Publicar e Receber',
                description: 'Com tópicos personalizados ativos, você pode editar os campos Publicar e Receber conforme a configuração do equipamento.',
                side: 'bottom',
                align: 'start',
                onPrevClick: selectProtocolAndMovePrev(tourManager, 'mqtt', '[data-tour="mqtt-topicos-personalizados"]'),
            },
        },
        {
            element: '[data-tour="mqtt-topicos-extras-pub"]',
            popover: {
                title: 'Tópicos extras',
                description: 'Ao lado de Publicar e Receber aparecem os botões "Tópicos extras", para o caso do equipamento possuir mais de um tópico.',
                side: 'bottom',
                align: 'start',
                onPrevClick: selectProtocolAndMovePrev(tourManager, 'mqtt', '[data-tour="mqtt-topico-publicar"]'),
            },
            onHighlighted: () => {
                const buttons = [
                    document.querySelector('[data-tour="mqtt-topicos-extras-pub"] button'),
                    document.querySelector('[data-tour="mqtt-topicos-extras-sub"] button'),
                ].filter(Boolean)

                const onExtrasClick = () => tourManager.minimize()

                buttons.forEach((button) => {
                    button.addEventListener('click', onExtrasClick)
                    button._hdvTourExtrasClick = onExtrasClick
                })
            },
            onDeselected: () => {
                const buttons = [
                    document.querySelector('[data-tour="mqtt-topicos-extras-pub"] button'),
                    document.querySelector('[data-tour="mqtt-topicos-extras-sub"] button'),
                ].filter(Boolean)

                buttons.forEach((button) => {
                    if (button._hdvTourExtrasClick) {
                        button.removeEventListener('click', button._hdvTourExtrasClick)
                        delete button._hdvTourExtrasClick
                    }
                })
            },
        },
        {
            element: '[data-tour="mqtt-alterar-senha"]',
            popover: {
                title: 'Alterar senha',
                description: 'Este checkbox gera uma nova senha MQTT aleatória ao salvar o formulário.',
                side: 'top',
                align: 'start',
                onPrevClick: selectProtocolAndMovePrev(tourManager, 'mqtt', '[data-tour="mqtt-topicos-extras-pub"]'),
            },
            onHighlighted: (element) => {
                const checkbox = element.querySelector('input[type="checkbox"]')
                if (!checkbox) return

                const onAlterarSenhaClick = () => tourManager.minimize()

                checkbox.addEventListener('click', onAlterarSenhaClick)
                checkbox._hdvTourAlterarSenhaClick = onAlterarSenhaClick
            },
            onDeselected: (element) => {
                const checkbox = element?.querySelector?.('input[type="checkbox"]')
                if (checkbox?._hdvTourAlterarSenhaClick) {
                    checkbox.removeEventListener('click', checkbox._hdvTourAlterarSenhaClick)
                    delete checkbox._hdvTourAlterarSenhaClick
                }
            },
        },
        {
            popover: {
                title: 'Sincronize com o equipamento',
                description: 'Alterações em tópicos, usuário e senha precisam ser feitas tanto no sistema quanto no equipamento. O sistema salva e aguarda que o equipamento tenha as mesmas configurações para conseguirem se comunicar.',
                onPrevClick: selectProtocolAndMovePrev(tourManager, 'mqtt', '[data-tour="mqtt-alterar-senha"]'),
            },
        },
    ]

    if (!skipGatewayOption) {
        steps.push(
            {
                element: '[data-tour="protocol-gateway"]',
                popover: {
                    title: 'Gateway',
                    description: 'Se quiser editar para Gateway, selecione esta opção e escolha a qual gateway o equipamento está vinculado.',
                    side: 'bottom',
                    align: 'start',
                    onNextClick: selectProtocolAndMoveNext(tourManager, 'gateway', '[data-tour="gateway-select"]'),
                    onPrevClick: () => tourManager.movePrevious(),
                },
            },
            {
                element: '[data-tour="gateway-select"]',
                popover: {
                    title: 'Selecione o Gateway',
                    description: 'Escolha aqui o gateway ao qual este equipamento está vinculado.',
                    side: 'right',
                    align: 'start',
                    onPrevClick: selectProtocolAndMovePrev(tourManager, 'gateway', '[data-tour="protocol-gateway"]'),
                },
            }
        )
    }

    steps.push(
        {
            element: () => {
                selectProtocol('http')
                return document.querySelector('[data-tour="protocol-http"]')
            },
            popover: {
                title: 'HTTP',
                description: 'Após salvar o equipamento, será gerada uma URL de comunicação. Clique em <strong>Próximo</strong> para ver onde encontrá-la e como utilizá-la.',
                side: 'bottom',
                align: 'start',
                onNextClick: selectProtocolAndMoveNext(tourManager, 'http', '[data-tour="detalhes-comunicacao-http"]'),
                onPrevClick: () => {
                    if (skipGatewayOption) {
                        tourManager.movePrevious()
                    } else {
                        selectProtocolAndMovePrev(tourManager, 'gateway', '[data-tour="gateway-select"]')()
                    }
                },
            },
        },
        {
            element: '[data-tour="detalhes-comunicacao-http"]',
            popover: {
                title: 'URL HTTP',
                description: 'Após salvar, esta URL fica válida para configurar no equipamento.',
                side: 'top',
                align: 'start',
                onPrevClick: () => {
                    selectProtocol('http')
                    setTimeout(() => tourManager.movePrevious(), 150)
                },
            },
            onHighlighted: () => selectProtocol('http'),
        }
    )

    return steps
}

const buildLnsProtocolSteps = (tourManager) => [
    {
        element: '[data-tour="form-protocolo-opcoes"]',
        popover: {
            title: 'Protocolo LNS',
            description: 'Este equipamento está configurado com LNS. Você pode mudar para outra opção de protocolo se desejar.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                clickTab('[data-tour="tab-protocolo"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
    },
    {
        element: () => {
            selectLns()
            return document.querySelector('[data-tour="detalhes-comunicacao-lns_interno"]')
        },
        popover: {
            title: 'Comunicação LNS',
            description: 'Esta é uma comunicação exclusiva do módulo LNS. Acesse o módulo LNS para maiores informações e configuração dos redirecionamentos internos.',
            side: 'top',
            align: 'start',
            onPrevClick: () => tourManager.movePrevious(),
        },
        onHighlighted: () => selectLns(),
    },
]

const buildParamImportSteps = (tourManager) => {
    const ensureReady = ensureImportModalOpen('param')

    return [
        {
            element: '[data-tour="param-import-tabs"]',
            ensureReady,
            popover: {
                title: 'Importar parâmetros',
                description: 'Escolha a origem dos parâmetros: Pessoal (modelos salvos por você), Global (modelos disponibilizados pela plataforma) ou Arquivo local (arquivo salvo no seu computador).',
                side: 'left',
                align: 'end',
                onPrevClick: closeModalAndMovePrev(tourManager, '[data-tour="param-import-fechar"]'),
                onNextClick: () => {
                    selectImportGlobalTab('param')
                    setTimeout(() => tourManager.moveNext(), 150)
                },
            },
            onHighlighted: () => selectImportGlobalTab('param'),
        },
        {
            element: getImportTableContent('param'),
            ensureReady,
            popover: {
                title: 'Selecionar template',
                description: 'Marque o checkbox na linha do template desejado para selecioná-lo.',
                side: 'top',
                align: 'center',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="param-import-confirmar"]',
            ensureReady,
            popover: {
                title: 'Importar',
                description: 'Com o template marcado, clique em Importar para subir os parâmetros.',
                side: 'top',
                align: 'end',
                onNextClick: closeModalAndMoveNext(tourManager, '[data-tour="param-import-fechar"]'),
                onPrevClick: () => {
                    selectImportGlobalTab('param')
                    setTimeout(() => tourManager.movePrevious(), 150)
                },
            },
        },
    ]
}

const buildCmdImportSteps = (tourManager) => {
    const ensureReady = ensureImportModalOpen('cmd')

    return [
        {
            element: '[data-tour="cmd-import-tabs"]',
            ensureReady,
            popover: {
                title: 'Importar comandos',
                description: 'Escolha a origem dos comandos: Pessoal (modelos salvos por você), Global (modelos disponibilizados pela plataforma) ou Arquivo local (arquivo salvo no seu computador).',
                side: 'left',
                align: 'end',
                onPrevClick: closeModalAndMovePrev(tourManager, '[data-tour="cmd-import-fechar"]'),
                onNextClick: () => {
                    selectImportGlobalTab('cmd')
                    setTimeout(() => tourManager.moveNext(), 150)
                },
            },
            onHighlighted: () => selectImportGlobalTab('cmd'),
        },
        {
            element: getImportTableContent('cmd'),
            ensureReady,
            popover: {
                title: 'Selecionar template',
                description: 'Marque o checkbox na linha do template desejado para selecioná-lo.',
                side: 'top',
                align: 'center',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="cmd-import-confirmar"]',
            ensureReady,
            popover: {
                title: 'Importar',
                description: 'Com o template marcado, clique em Importar para subir os comandos.',
                side: 'top',
                align: 'end',
                onNextClick: closeModalAndMoveNext(tourManager, '[data-tour="cmd-import-fechar"]'),
                onPrevClick: () => {
                    selectImportGlobalTab('cmd')
                    setTimeout(() => tourManager.movePrevious(), 150)
                },
            },
        },
    ]
}

const buildParametrizacaoSection = (tourManager, equipamentoId, { indexStart, onPrevFromTab, afterHelpNext }) => {
    const showParamTour = canShowParamTour()

    if (!showParamTour) {
        return [
            {
                element: '[data-tour="tab-parametrizacao"]',
                popover: {
                    title: 'Aba Parametrização',
                    description: 'Esta aba é liberada após salvar o equipamento. Clique em <strong>Próximo</strong> para abri-la.',
                    side: 'bottom',
                    align: 'start',
                    onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-parametrizacao"]'),
                    onPrevClick: onPrevFromTab,
                },
            },
            {
                element: '[data-tour="param-aviso-comunicacao"]',
                popover: {
                    title: 'Aguardando comunicação',
                    description: 'O equipamento ainda não comunicou com o servidor e não possui parâmetros cadastrados. Volte a esta aba quando ele já tiver enviado pacotes.',
                    side: 'bottom',
                    align: 'center',
                    onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-parametrizacao"]'),
                },
            },
        ]
    }

    const indexOptionsStep = indexStart + 1
    const indexNewButtonStep = indexStart + 5
    const indexHelpStep = indexStart + 6

    return [
        {
            element: '[data-tour="tab-parametrizacao"]',
            popover: {
                title: 'Aba Parametrização',
                description: 'Esta aba é essencial para finalizar os cadastros básicos iniciais. Clique em <strong>Próximo</strong> para abri-la.',
                side: 'bottom',
                align: 'start',
                onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-parametrizacao"]'),
                onPrevClick: onPrevFromTab,
            },
        },
        {
            element: '[data-tour="param-options"]',
            popover: {
                title: 'Opções',
                description: 'Pelo botão Opções você importa parametrizações prontas. Clique em <strong>Próximo</strong> para abrir a importação.',
                side: 'left',
                align: 'start',
                onNextClick: openDropdownAndImport(
                    tourManager,
                    '[data-tour="param-options"]',
                    '[data-tour="param-importar"]',
                    '[data-tour="param-import-modal-wrap"]'
                ),
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-parametrizacao"]'),
            },
        },
        ...buildParamImportSteps(tourManager),
        {
            element: '[data-tour="param-novo-btn"]',
            popover: {
                title: 'Novo parâmetro',
                description: 'Use para criar suas próprias fórmulas. A parametrização é essencial para finalizar os cadastros básicos iniciais. Clique em <strong>Próximo</strong> para abrir a tela.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                    tourManager.navigateAndWait(`/campo-parametrizado/${resolvedEquipamentoId}/novo`, '[data-tour="help-campo-parametrizado"]', indexHelpStep)
                        .then(() => tourManager.moveTo(indexHelpStep))
                        .catch(() => {})
                },
                onPrevClick: () => {
                    clickTab('[data-tour="tab-parametrizacao"]')
                    setTimeout(() => {
                        document.querySelector('[data-tour="param-options"]')?.click()
                        setTimeout(() => {
                            document.querySelector('[data-tour="param-importar"]')?.click()
                            tourManager.waitForElement('[data-tour="param-import-confirmar"]')
                                .then(() => tourManager.moveTo(indexOptionsStep + 3))
                                .catch(() => tourManager.moveTo(indexOptionsStep))
                        }, 150)
                    }, 150)
                },
            },
        },
        {
            element: '[data-tour="help-campo-parametrizado"]',
            popover: {
                title: 'Ajuda desta tela',
                description: `Recomendamos concluir este guia primeiro. Depois, volte a esta aba e clique no ícone de <strong>Ajuda</strong> ${HELP_ICON_HTML} para iniciar o guia completo de parametrização.<br><br>Se preferir, você também pode <a href="#" class="hdv-tour-start-link" data-hdv-start-tour="parametrizacao">iniciar esse guia agora mesmo</a>.`,
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                    if (afterHelpNext) {
                        afterHelpNext(resolvedEquipamentoId)
                        return
                    }

                    goToEditStep(tourManager, resolvedEquipamentoId, '[data-tour="equipamento-edit-root"]', indexHelpStep + 1)
                },
                onPrevClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                    goToEditStep(
                        tourManager,
                        resolvedEquipamentoId,
                        '[data-tour="param-novo-btn"]',
                        indexNewButtonStep,
                        '[data-tour="tab-parametrizacao"]'
                    )
                },
            },
            onHighlighted: (element) => {
                bindElementHandoffClick(
                    element,
                    tourManager,
                    'editar-equipamento',
                    'parametrizacao',
                    '[data-tour="help-campo-parametrizado"]'
                )
                bindStartTourLink(
                    tourManager,
                    'editar-equipamento',
                    'parametrizacao',
                    '[data-tour="help-campo-parametrizado"]'
                )
            },
            onDeselected: (element) => {
                unbindElementHandoffClick(element)
            },
        },
    ]
}

const buildEditarEquipamentoTourSteps = (tourManager) => {
    const mqtt = isMqttEquipment()
    const gateway = isGatewayEquipment()
    const virtual = isVirtualEquipment()
    const lnsActive = isLnsProtocol() && hasLnsOption()
    const equipamentoId = getEquipamentoId()
    const accessState = hasAccessState()
    const campoGateway = hasCampoGateway()
    const savedProtocol = getSavedProtocol()

    tourManager.setTourCleanup?.(() => restoreSavedProtocol(savedProtocol))

    const ensureEquipamentoTab = () => {
        clickTab('[data-tour="tab-equipamento"]')
        return Promise.resolve()
    }

    const steps = [
        {
            ensureReady: ensureEquipamentoTab,
            onHighlighted: () => ensureEquipamentoTab(),
            popover: {
                title: 'Equipamento cadastrado',
                description: virtual
                    ? 'Este é um equipamento virtual já cadastrado. Neste cenário ficam disponíveis as abas Equipamento e Parametrização.'
                    : gateway
                        ? 'Este é um equipamento gateway já cadastrado. Neste cenário ficam disponíveis as abas Equipamento e Protocolo.'
                        : 'Este é um equipamento já cadastrado e pode ser editado. Vamos percorrer as opções disponíveis após o salvamento inicial.',
            },
        },
        {
            element: '[data-tour="tab-equipamento"]',
            ensureReady: ensureEquipamentoTab,
            popover: {
                title: 'Aba Equipamento',
                description: 'Esta aba reúne os dados básicos do cadastro. Alguns destes campos podem ser alterados quando você desejar; basta ajustar e salvar novamente.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    clickTab('[data-tour="tab-equipamento"]')
                    setTimeout(() => tourManager.moveNext(), 150)
                },
            },
        },
    ]

    if (accessState) {
        steps.push({
            element: '[data-tour="form-estado-acesso"]',
            ensureReady: ensureEquipamentoTab,
            popover: {
                title: 'Estado do acesso',
                description: 'O acesso define a quantidade máxima de parâmetros que podem ser cadastrados no equipamento. A barra mostra quantos já foram utilizados e quantos ainda estão disponíveis.',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    if (campoGateway) {
        steps.push({
            element: '[data-tour="form-campo-gateway"]',
            ensureReady: ensureEquipamentoTab,
            popover: {
                title: 'Campo ID do equipamento',
                description: 'Informe onde estão os dados dos dispositivos na mensagem do gateway. Exemplo: data.0.bn',
                side: 'top',
                align: 'start',
            },
        })
    }

    if (virtual) {
        const indexParametrizationStart = steps.length

        steps.push(
            ...buildParametrizacaoSection(tourManager, equipamentoId, {
                indexStart: indexParametrizationStart,
                onPrevFromTab: () => tourManager.movePrevious(),
                afterHelpNext: (resolvedEquipamentoId) => {
                    goToEditStep(tourManager, resolvedEquipamentoId, '[data-tour="equipamento-edit-root"]', indexParametrizationStart + 7)
                },
            })
        )

        steps.push({
            popover: {
                title: 'Pronto!',
                description: 'Você concluiu o tour deste equipamento virtual. A parametrização continua essencial.<br><br>Para alimentar os parâmetros e os gráficos do monitorado, use o <strong>Reporte Manual</strong>: é lá que o equipamento virtual envia pacotes manualmente.<br><br><a href="#" class="hdv-tour-start-link" data-hdv-start-tour="reporte-manual">Clique aqui</a> para iniciar o guia de Reporte Manual.',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: () => {
                bindReporteManualTourLink(tourManager, 'editar-equipamento')
            },
        })

        return steps
    }

    steps.push({
        element: '[data-tour="tab-protocolo"]',
        popover: {
            title: 'Aba Protocolo',
            description: 'Aqui você pode alterar a forma de comunicação do equipamento. Clique em <strong>Próximo</strong> para abrir a aba.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-protocolo"]'),
        },
    })

    if (lnsActive) {
        steps.push(...buildLnsProtocolSteps(tourManager))
    } else {
        steps.push(
            {
                element: '[data-tour="form-protocolo-opcoes"]',
                popover: {
                    title: 'Protocolo de comunicação',
                    description: gateway
                        ? 'Você pode mudar a opção de protocolo a qualquer momento: MQTT, HTTP ou Outro.'
                        : 'Você pode mudar a opção de protocolo a qualquer momento: MQTT, Gateway, HTTP ou Outro.',
                    side: 'bottom',
                    align: 'start',
                    onPrevClick: () => {
                        clickTab('[data-tour="tab-protocolo"]')
                        setTimeout(() => tourManager.movePrevious(), 150)
                    },
                },
            },
            ...buildMqttProtocolSteps(tourManager, { skipGatewayOption: gateway })
        )
    }

    if (gateway) {
        steps.push({
            popover: {
                title: 'Pronto!',
                description: 'Você concluiu o tour de edição deste equipamento gateway.',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: () => restoreSavedProtocol(savedProtocol),
        })

        return steps
    }

    const indexLastProtocolStep = steps.length - 1
    const indexParametrizationStart = steps.length
    const showParamTour = canShowParamTour()

    const lastProtocolStep = steps[indexLastProtocolStep]
    if (lastProtocolStep?.popover) {
        lastProtocolStep.popover.onNextClick = () => {
            restoreSavedProtocol(savedProtocol)
            setTimeout(() => tourManager.moveTo(indexParametrizationStart), 200)
        }
    }

    steps.push(
        ...buildParametrizacaoSection(tourManager, equipamentoId, {
            indexStart: indexParametrizationStart,
            onPrevFromTab: () => goBackToLastProtocolStep(tourManager, indexLastProtocolStep, lnsActive),
            afterHelpNext: (resolvedEquipamentoId) => {
                const commandsTabStepIndex = showParamTour ? indexParametrizationStart + 7 : indexParametrizationStart + 2

                goToEditStep(tourManager, resolvedEquipamentoId, '[data-tour="tab-comandos"]', commandsTabStepIndex)
            },
        })
    )

    const paramTabStep = steps[indexParametrizationStart]
    if (paramTabStep) {
        const previousOnHighlighted = paramTabStep.onHighlighted
        paramTabStep.onHighlighted = (...args) => {
            restoreSavedProtocol(savedProtocol)
            if (typeof previousOnHighlighted === 'function') {
                previousOnHighlighted(...args)
            }
        }
    }

    const indexBeforeCommands = steps.length
    const indexCommandsHelpStep = indexBeforeCommands + 6
    const indexCommandsNewStep = indexBeforeCommands + 5

    const indexLastParamStep = indexBeforeCommands - 1

    steps.push(
        {
            element: '[data-tour="tab-comandos"]',
            popover: {
                title: 'Aba Comandos',
                description: 'Aqui você cadastra comandos enviados ao equipamento. Comandos são necessários caso voce pretender trabalhar com automações no Monitorado.',
                side: 'bottom',
                align: 'start',
                onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-comandos"]'),
                onPrevClick: () => {
                    if (showParamTour) {
                        const resolvedEquipamentoId = getEquipamentoId() || equipamentoId
                        const helpStepIndex = indexParametrizationStart + 6

                        tourManager.navigateAndWait(`/campo-parametrizado/${resolvedEquipamentoId}/novo`, '[data-tour="help-campo-parametrizado"]', helpStepIndex)
                            .then(() => tourManager.moveTo(helpStepIndex))
                            .catch(() => {})
                        return
                    }

                    clickTab('[data-tour="tab-parametrizacao"]')
                    setTimeout(() => tourManager.moveTo(indexLastParamStep), 150)
                },
            },
        },
        {
            element: '[data-tour="cmd-options"]',
            popover: {
                title: 'Opções de comandos',
                description: 'Pelo botão Opções você também importa comandos prontos. Clique em <strong>Próximo</strong> para abrir a importação.',
                side: 'left',
                align: 'start',
                onNextClick: openDropdownAndImport(
                    tourManager,
                    '[data-tour="cmd-options"]',
                    '[data-tour="cmd-importar"]',
                    '[data-tour="cmd-import-modal-wrap"]'
                ),
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-comandos"]'),
            },
        },
        ...buildCmdImportSteps(tourManager),
        {
            element: '[data-tour="cmd-novo-btn"]',
            popover: {
                title: 'Novo comando',
                description: 'Disponível mesmo sem o equipamento ter comunicado. Clique em <strong>Próximo</strong> para abrir a tela de cadastro.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                    tourManager.navigateAndWait(`/comando-customizado/${resolvedEquipamentoId}/novo`, '[data-tour="help-comando-customizado"]', indexCommandsHelpStep)
                        .then(() => tourManager.moveTo(indexCommandsHelpStep))
                        .catch(() => {})
                },
                onPrevClick: () => {
                    clickTab('[data-tour="tab-comandos"]')
                    setTimeout(() => {
                        document.querySelector('[data-tour="cmd-options"]')?.click()
                        setTimeout(() => {
                            document.querySelector('[data-tour="cmd-importar"]')?.click()
                            tourManager.waitForElement('[data-tour="cmd-import-confirmar"]')
                                .then(() => tourManager.moveTo(indexBeforeCommands + 4))
                                .catch(() => tourManager.moveTo(indexBeforeCommands + 1))
                        }, 150)
                    }, 150)
                },
            },
        },
        {
            element: '[data-tour="help-comando-customizado"]',
            popover: {
                title: 'Ajuda desta tela',
                description: `Recomendamos concluir este guia primeiro. Depois, volte a esta aba e clique no ícone de <strong>Ajuda</strong> ${HELP_ICON_HTML} para iniciar o guia de comandos.<br><br>Se preferir, você também pode <a href="#" class="hdv-tour-start-link" data-hdv-start-tour="comandos">iniciá-lo agora</a>.`,
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId
                    const nextStepIndex = indexBeforeCommands + 7
                    const selector = mqtt
                        ? '[data-tour="tab-dados-vivo"]'
                        : '[data-tour="equipamento-edit-root"]'

                    goToEditStep(tourManager, resolvedEquipamentoId, selector, nextStepIndex)
                },
                onPrevClick: () => {
                    const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                    goToEditStep(
                        tourManager,
                        resolvedEquipamentoId,
                        '[data-tour="cmd-novo-btn"]',
                        indexCommandsNewStep,
                        '[data-tour="tab-comandos"]'
                    )
                },
            },
            onHighlighted: (element) => {
                bindElementHandoffClick(
                    element,
                    tourManager,
                    'editar-equipamento',
                    'comandos',
                    '[data-tour="help-comando-customizado"]'
                )
                bindStartTourLink(
                    tourManager,
                    'editar-equipamento',
                    'comandos',
                    '[data-tour="help-comando-customizado"]'
                )
            },
            onDeselected: (element) => {
                unbindElementHandoffClick(element)
            },
        }
    )

    if (mqtt) {
        steps.push(
            {
                element: '[data-tour="tab-dados-vivo"]',
                popover: {
                    title: 'Dados ao vivo',
                    description: 'Disponível apenas para equipamentos MQTT. Clique em <strong>Próximo</strong> para abrir a aba.',
                    side: 'bottom',
                    align: 'start',
                    onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-dados-vivo"]'),
                    onPrevClick: () => {
                        const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                        tourManager.navigateAndWait(`/comando-customizado/${resolvedEquipamentoId}/novo`, '[data-tour="help-comando-customizado"]', indexCommandsHelpStep)
                            .then(() => tourManager.moveTo(indexCommandsHelpStep))
                            .catch(() => {})
                    },
                },
            },
            {
                element: '[data-tour="mqtt-preview"]',
                popover: {
                    title: 'Pacotes MQTT',
                    description: 'Esta tabela se conecta ao socket do servidor e mostra os pacotes MQTT do equipamento em tempo real.',
                    side: 'top',
                    align: 'center',
                    onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-dados-vivo"]'),
                },
            },
            {
                element: '[data-tour="mqtt-preview-ultima-vez"]',
                popover: {
                    title: 'Visto por último',
                    description: 'Aqui você acompanha quando o equipamento foi visto por último pelo servidor.',
                    side: 'top',
                    align: 'start',
                },
            }
        )
    }

    steps.push({
        popover: {
            title: 'Pronto!',
            description: 'Lembre-se: a parametrização é essencial para finalizar os cadastros básicos iniciais e será necessária também no Monitorado.',
            onPrevClick: () => {
                const resolvedEquipamentoId = getEquipamentoId() || equipamentoId

                if (!window.location.pathname.includes('/equipamento/') && resolvedEquipamentoId) {
                    const selector = mqtt
                        ? '[data-tour="mqtt-preview-ultima-vez"]'
                        : '[data-tour="help-comando-customizado"]'

                    goToEditStep(tourManager, resolvedEquipamentoId, selector, steps.length - 2, mqtt ? '[data-tour="tab-dados-vivo"]' : null)
                    return
                }

                tourManager.movePrevious()
            },
        },
    })

    return steps
}

export default buildEditarEquipamentoTourSteps
